export default {
    isEditGroupDialogOpen: false,
    isEditOptionDialogOpen: false,
    editGroupItem: {},
    editOptionItem: {},
    workerFeePerStoreGroupList: [],
    workerFeePerStoreGroupOptionList: [],
    selectedFeeGroup: {},
};
